<app-header></app-header>
<div class="page-title-area page-title-style-two item-rights bg-auction">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Achizitii si Licitatii</li>
            </ul>
            <h2>Achizitii si Licitatii</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">

                <h2>Licitatii si achizitii publice</h2>
                <h4>16.02.2022 NEGOCIERE FARA PUBLICARE PREALABILA A UNUI ANUNT DE PARTICIPARE</h4>
                <a href="../../../assets/img/pdf/documentatie.pdf" download="Documentatie de atribuire">
                    Documentatie de atribuire
                  </a>
            </div>
        </div>
    </div>
</div>
